import { LayoutAdminTable } from 'app/components/templates/LayoutAdminTable';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { DataTable } from 'app/components/elements/TableCustom';
import { useRedemption } from './hooks';
import { Stack, Typography } from '@mui/material';
import { StatusRedemptions } from 'const/option';
import { capitalizeFirstLetter } from 'const/common';
import { EditableDateCell } from '../../../components/elements/EditableDateCell';

export const RedemptionPage = () => {
  const {
    size,
    rowsPost,
    rowsPre,
    totalPost,
    totalPre,
    pagePost,
    pagePre,
    onChangePagePost,
    onChangePagePre,
    asyncUpdateRedemption,
    handleClickRow
  } = useRedemption();

  const renderHeader: (value: { isPre?: boolean }) => GridColDef[] = ({
    isPre
  }: {
    isPre?: boolean;
  }) => {
    return [
      {
        field: 'status',
        headerName: 'Status',
        width: 200,
        renderCell: (params: GridRenderCellParams) => {
          const status = params?.row?.fileStatusTransition?.status;
          const findStatus = StatusRedemptions.find((item) => item.value === status);
          return (
            <Stack
              style={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'row',
                gap: 10
              }}>
              <Stack
                style={{
                  background: findStatus?.color || '#9747FF',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0px 10px',
                  height: '20px',
                  borderRadius: '5px'
                }}>
                <Typography
                  style={{
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: 600
                  }}>
                  {capitalizeFirstLetter(findStatus?.value.replace('_', ' ') || 'Pre Seizure')}
                </Typography>
              </Stack>
              {params.row.isFileReopen && (
                <Stack
                  style={{
                    background: params.row.isFileReopen ? '#FF4773' : 'blue',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0px 10px',
                    height: '20px',
                    borderRadius: '5px'
                  }}>
                  <Typography
                    style={{
                      color: '#fff',
                      fontSize: '10px',
                      fontWeight: 600
                    }}>
                    Reopened
                  </Typography>
                </Stack>
              )}
            </Stack>
          );
        }
      },
      {
        field: 'fileNumber',
        headerName: 'File Number',
        width: 100
      },
      {
        field: 'firstName',
        headerName: 'First Name',
        width: 100
      },
      { field: 'lastName', headerName: 'Last Name', width: 100 },
      {
        field: 'statementSent',
        headerName: 'Statement Sent',
        width: 260,
        renderCell: (params: GridRenderCellParams) => {
          const status = params?.row?.fileStatusTransition?.status;
          const id =
            status === 'POST_SEIZURE'
              ? params?.row?.filePostSeizures?.id
              : params?.row?.filePreSeizures?.id;
          if (status !== 'POST_SEIZURE') {
            console.log(status);
            console.log(id);
          }
          return (
            <EditableDateCell
              value={
                status === 'POST_SEIZURE'
                  ? params?.row?.filePostSeizures?.statementSent
                  : params?.row?.filePreSeizures?.statementSent
              }
              onSave={async (newDate) => {
                await asyncUpdateRedemption({
                  status,
                  fileId: Number(params?.row?.id),
                  documentIds:
                    params?.row?.fileDocuments?.map((item: { storageId: number }) =>
                      Number(item.storageId)
                    ) || [],
                  id,
                  statementSent: newDate
                });
              }}
            />
          );
        }
      },
      {
        field: 'followupSent',
        headerName: 'Followup Sent',
        width: 260,
        renderCell: (params: GridRenderCellParams) => {
          const status = params?.row?.fileStatusTransition?.status;
          const id =
            status === 'POST_SEIZURE'
              ? params?.row?.filePostSeizures?.id
              : params?.row?.filePreSeizures?.id;
          return (
            <EditableDateCell
              value={
                status === 'POST_SEIZURE'
                  ? params?.row?.filePostSeizures?.followUpSent
                  : params?.row?.filePreSeizures?.followUpSent
              }
              onSave={async (newDate) => {
                await asyncUpdateRedemption({
                  status,
                  documentIds:
                    params?.row?.fileDocuments?.map((item: { storageId: number }) =>
                      Number(item.storageId)
                    ) || [],
                  fileId: Number(params?.row?.id),
                  id,
                  followUpSent: newDate
                });
              }}
            />
          );
        }
      },
      {
        field: 'apptSent',
        headerName: isPre ? 'Final Followup Sent' : 'Appt Date',
        width: 260,
        renderCell: (params: GridRenderCellParams) => {
          const status = params?.row?.fileStatusTransition?.status;
          const id =
            status === 'POST_SEIZURE'
              ? params?.row?.filePostSeizures?.id
              : params?.row?.filePreSeizures?.id;

          return (
            <EditableDateCell
              hasTime={!isPre}
              value={
                status === 'POST_SEIZURE'
                  ? params?.row?.filePostSeizures?.apptDate
                  : params?.row?.filePreSeizures?.apptDate
              }
              onSave={async (newDate) => {
                await asyncUpdateRedemption({
                  status,
                  documentIds:
                    params?.row?.fileDocuments?.map((item: { storageId: number }) =>
                      Number(item.storageId)
                    ) || [],
                  fileId: Number(params?.row?.id),
                  id,
                  apptDate: newDate
                });
              }}
            />
          );
        }
      },
      {
        field: 'auctionDeliveryLocation',
        headerName: 'Auction',
        width: 120,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Stack
              style={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'row',
                gap: 10
              }}>
              <Typography
                style={{
                  fontSize: '14px'
                }}>
                {params?.row.auctionDeliveryLocation?.value}
              </Typography>
            </Stack>
          );
        }
      },
      {
        field: 'Quick Note',
        headerName: 'Quick Note',
        width: 500,
        renderCell: (params: GridRenderCellParams) => {
          return (
            <Stack
              style={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                height: '100%',
                flexDirection: 'row',
                gap: 10
              }}>
              <Typography
                style={{
                  fontSize: '14px'
                }}>
                {params?.row.quickNote}
              </Typography>
            </Stack>
          );
        }
      }
    ];
  };

  return (
    <LayoutAdminTable title={'Redemptions'}>
      <Typography fontWeight={800} fontSize={20} mb={2}>
        Pre Seizure
      </Typography>
      <DataTable
        height={'100%'}
        maxHeight={1200}
        data={rowsPre}
        totalRows={totalPre}
        paginationModel={{
          page: pagePre ? Number(pagePre) - 1 : 1,
          pageSize: size
        }}
        loading={false}
        handlePaginationModelChange={(newPaginationModel) =>
          onChangePagePre(newPaginationModel.page + 1)
        }
        handleRowClick={(params) => {
          const isPostSeizure = params.row?.fileStatusTransition?.status === 'POST_SEIZURE';
          handleClickRow(
            params.row.filePostSeizures.id || params.row.filePreSeizures.id,
            isPostSeizure,
            Number(params.row.id)
          );
        }}
        header={renderHeader({ isPre: true })}
      />
      <Typography fontWeight={800} fontSize={20} mb={2} mt={3}>
        Post Seizure
      </Typography>
      <DataTable
        height={'100%'}
        maxHeight={1000}
        data={rowsPost}
        totalRows={totalPost}
        paginationModel={{
          page: pagePost ? Number(pagePost) - 1 : 1,
          pageSize: size
        }}
        loading={false}
        handlePaginationModelChange={(newPaginationModel) =>
          onChangePagePost(newPaginationModel.page + 1)
        }
        handleRowClick={(params) => {
          const isPostSeizure = params.row?.fileStatusTransition?.status === 'POST_SEIZURE';
          handleClickRow(
            params.row.filePostSeizures.id || params.row.filePreSeizures.id,
            isPostSeizure,
            Number(params.row.id)
          );
        }}
        header={renderHeader({})}
      />
    </LayoutAdminTable>
  );
};
